import React, { useRef, useState } from "react";
import { estructuraLogsFServ } from "../../utils/estructuras";

// Alertas
import Swal from 'sweetalert2'
import { getNewFormattedDate } from "../../utils/funciones";

const ModalFormFServ = ({activo,usuario,index,minimizar,actualizarFServ,actualizaractivoList,checkIfActivoHasODTForBreaking, calcularMantenimientoByActivo}) => {

    const [logToUpload,setLogToUpload] = useState({...estructuraLogsFServ,evento:(activo.actStatus != undefined && activo.actStatus == 'FSERV') ? 'DISPO' : 'FSERV',fecha:getNewFormattedDate(),activoID:activo._id,comUserID:usuario._id,userName:usuario.userName});
    const [titulo,setTitutlo] = useState(`Está seguro que desea establecer como ${(activo.actStatus == 'FSERV') ? 'Disponible' : 'Fuera de Servicio'} el activo ${activo.name} ?`);
    const refAlreadyClicked = useRef(false);

    const handleUpdateFServ = async() =>{
        if(refAlreadyClicked.current)return;
        refAlreadyClicked.current = true;
        let enableActivo = true;
        if(activo.actStatus == 'FSERV') enableActivo = await checkIfActivoHasODTForBreaking(activo._id);
        if(enableActivo){
            const res = await actualizarFServ(activo._id, activo.actStatus, logToUpload);
            if(res.actualizado){
                minimizar();
                calcularMantenimientoByActivo({...activo, actStatus: logToUpload.evento});
                Swal.fire({
                    title: `Disponibilidad modificada correctamente!`,
                    icon: 'success',
                    text: `Se establecio el activo como ${(activo.actStatus == 'FSERV') ? 'Disponible' : 'Fuera de Servicio'}`,//${resp.tDocNroFor}
                    showConfirmButton: true,
                    allowEnterKey: true
                });
            }else{
                Swal.fire({
                    title: `Algo no funciono segun lo esperado!`,
                    icon: 'error',
                    text: `La disponibilidad para el activo ${activo.name} no se guardo correctamente!`,//${resp.tDocNroFor}
                    showConfirmButton: true,
                    allowEnterKey: true
                });
            }
        }else{
            minimizar();
            Swal.fire({
                title: `No es posible establecer como Disponible!`,
                icon: 'error',
                text: `El activo posee ordenes de trabajo generadas por rotura`,//${resp.tDocNroFor}
                showConfirmButton: true,
                allowEnterKey: true
            });
        } 
        refAlreadyClicked.current = false; //Borra esta linea luego
    }
    

    return <div className="modalFormDiv modalFormFServDiv">
        <button className="minimizarBtn" onClick={minimizar}>X</button>
        <div className="headerModalForm">Modificar Disponibilidad</div>
        <div className="bodyModalForm">
            <h6>{titulo}</h6>
            <div className="buttonsModalDiv">
                <button className="modalFormBtn" id="updFServBtn" onClick={()=>handleUpdateFServ()}>Sí, estoy seguro</button>    
                <button className="modalFormBtn" id="cancelBtn" onClick={minimizar}>No</button>    
            </div>
        </div>
    </div>

}

export default ModalFormFServ;